<template>
  <div class="ceping-setting">
    <van-cell-group>
      <van-cell
        is-link
        v-for="(item, index) in list"
        :key="index"
        :title="item.name"
        :label="item.subName"
        @click="goDetail(item.link)">
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: '测评设置',
      list: [{
        name: '测评项目设置',
        subName: '自定义测评项目',
        link: 'cepingItemSetting'
      },{
        name: '项目类型设置',
        subName: '自定义测评项目的类型，便于在模板中快捷选择测评项目',
        link: 'cepingCategorySetting'
      }]
    }
  },
  methods: {
    goDetail(link) {
      this.$router.push(link);
    }
  }
}
</script>